goog.provide("shadow.js.shim.module$$mui$material$Backdrop$default");
shadow.js.shim.module$$mui$material$Backdrop$default = shadow.js.shim.module$$mui$material$Backdrop.default;
